export const tipoGeneracion = {
    PDF: 1,
    CORREO: 2
}